import { useMemo } from "react";
import { useSelector } from "react-redux";

/**
 * Returns plan limits, trial status, and derived flags for gating features.
 * Depends on billing.plan (fetch via fetchPlan() in layout or page).
 * @param {Object} options
 * @param {number} [options.storeCount] - Current number of stores (for canAddStore).
 */
export function usePlanLimits(options = {}) {
  const { storeCount = 0 } = options;
  const planData = useSelector((state) => state.billing?.plan) || null;

  const limits = planData?.limits || {};
  const plan = planData?.plan ?? null;
  const planName = planData?.planName ?? null;
  const isTrialing = planData?.isTrialing === true;
  const trialEndsAt = planData?.trialEndsAt ?? null;
  const subscriptionStatus = planData?.subscriptionStatus ?? null;

  const storeLimit = limits.stores;
  const trialExpired =
    plan === "free_trial" &&
    !isTrialing &&
    (subscriptionStatus === "expired" || (trialEndsAt && new Date(trialEndsAt) <= new Date()));

  const canAddStore = useMemo(() => {
    if (storeLimit === undefined || storeLimit === null) return true;
    if (storeLimit === -1) return true;
    return storeCount < storeLimit;
  }, [storeLimit, storeCount]);

  const storeLimitReached = storeLimit != null && storeLimit !== -1 && storeCount >= storeLimit;

  return {
    limits,
    plan,
    planName,
    isTrialing,
    trialEndsAt,
    trialExpired,
    storeLimit: storeLimit === -1 ? null : storeLimit,
    canAddStore,
    storeLimitReached,
    storeCountUsed: storeCount,
  };
}
